(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('slideshow-thumbnails', class extends baseComponent.default {
      elements = {
          items: '*[data-item]'
      }
      onSliderLoad(slider) {
          this.slider = slider;
          this._setActive(this.slider.swiper.activeIndex);
          this.$items.map((item, i) => {
              item.addEventListener('click', () => {
                  this.slider.slideTo(i);
                
                  if(product){
                    console.log({target: {name: 'Color', value: 'Select Colour', hasAttribute: ()=>{}}});
                    this.slider.$variantSelector._variantChangeHandler({target: {name: 'Color', value: 'Select Colour', hasAttribute: ()=>{}}});
                    ///this.slider.$variantSelector._toogleInputs({name: 'Color', value: 'Select Colour', hasAttribute: ()=>{}});
                  }
              });
          })
          this.slider.swiper.on('slideChange', () => {
              this._setActive(this.slider.swiper.activeIndex);
          })
      }
      _setActive(index) {
          if(this.active) {
              this.active.classList.remove('!active');
          }
          this.active = this.$items[index];
          this.active.classList.add('!active');
          if(this.hasAttribute('horizontal')) {
              this.active.parentNode.scrollLeft = this.active.offsetLeft - 200;
          } else {
              this.active.parentNode.scrollTop = this.active.offsetTop - 200;
          }
      }
  });
})();

(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('slideshow-thumbnails-color', class extends baseComponent.default {
      elements = {
          items: '*[data-item]'
      }
      onSliderLoad(slider) {
          this.slider = slider;
          this._setActive(this.slider.swiper.activeIndex);
          this.$items.map((item, i) => {
              item.addEventListener('click', () => {
                  this.slider.slideTo(i);
                
                  if(product){
                    let variant = '';
                    for(let x = 0; x < product.variants.length; x++){
                      if(product.variants[x].featured_media.position == (i + 1))variant = product.variants[x];
                    }
                    ///this.slider.$variantSelector._toogleInputs({name: 'Color', value: variant.option1, hasAttribute: ()=>{}});
                    this.slider.$variantSelector._variantChangeHandler({target: {name: 'Color', value: variant.option1, hasAttribute: ()=>{}}});
                  }
              });
          })
          this.slider.swiper.on('slideChange', () => {
              this._setActive(this.slider.swiper.activeIndex);
          })
      }
      _setActive(index) {
        //console.log(">>>>>>>>>>", index);
          if(this.active) {
              this.active.classList.remove('!active');
          }
          this.active = this.$items[index];
          this.active.classList.add('!active');
          if(this.hasAttribute('horizontal')) {
              this.active.parentNode.scrollLeft = this.active.offsetLeft - 200;
          } else {
              this.active.parentNode.scrollTop = this.active.offsetTop - 200;
          }
      }
  });
})();
